var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "22px",
    viewBox: "0 0 21 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5F4FFB40-488A-466B-BF3F-1E05C48509BE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "system-design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "qsd-02.4",
    transform: "translate(-304.000000, -42.000000)",
    fill: "#24637D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.806696,57.8297612 C316.871843,57.944663 316.953461,58.0528315 317.051486,58.1508574 L322.397694,63.4970652 C322.983201,64.0825719 323.919141,64.0785913 324.498866,63.498866 C325.082633,62.9150989 325.077785,61.978414 324.497065,61.3976941 L319.150857,56.0514863 C319.11188,56.0125086 319.071349,55.9761433 319.029474,55.9423863 C320.259749,54.4679709 321,52.5704329 321,50.5 C321,45.8055796 317.19442,42 312.5,42 C307.80558,42 304,45.8055796 304,50.5 C304,55.1944204 307.80558,59 312.5,59 C314.071681,59 315.543732,58.5734347 316.806696,57.8297612 Z M312.5,57 C308.910149,57 306,54.0898509 306,50.5 C306,46.9101491 308.910149,44 312.5,44 C316.089851,44 319,46.9101491 319,50.5 C319,54.0898509 316.089851,57 312.5,57 Z",
    id: "icon-search"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.729123fe0ddb31d1924a96f38be8b1ce.svg";
export { ForwardRef as ReactComponent };